import { Link } from "react-router-dom";
import { Home, Compass } from "lucide-react";

export default function NotFound() {
    return (
        <div className="min-h-[70vh] bg-cream-50 flex flex-col items-center justify-center px-6 text-center py-16" data-testid="not-found-page">
            <div className="w-20 h-20 rounded-full bg-gold-500/10 border border-gold-500/30 flex items-center justify-center mb-4">
                <Compass className="w-9 h-9 text-gold-600" />
            </div>
            <div className="text-[10px] uppercase tracking-widest text-navy-500/50 font-bold">Error 404</div>
            <h1 className="font-heading font-bold text-2xl text-navy-500 mt-1 mb-2">Page not found</h1>
            <p className="text-sm text-navy-500/60 max-w-sm">
                The page you&apos;re looking for doesn&apos;t exist or has moved. Try browsing our properties or head back home.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-2 w-full max-w-sm">
                <Link
                    to="/"
                    data-testid="not-found-home"
                    className="flex-1 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-lg bg-gold-500 text-navy-500 text-sm font-extrabold hover:bg-gold-400"
                >
                    <Home className="w-4 h-4" /> Go Home
                </Link>
                <Link
                    to="/properties"
                    data-testid="not-found-properties"
                    className="flex-1 inline-flex items-center justify-center px-4 py-2.5 rounded-lg border border-navy-500/25 text-navy-500 text-sm font-semibold hover:bg-navy-500/5"
                >
                    Browse Properties
                </Link>
            </div>
        </div>
    );
}
